import * as Yup from 'yup';

export const ItemSchema = (initialValues, context) => {
  // title field must be validated only when more than one group is created
  const isNewItem = Object.keys(initialValues).length === 0
  const isFirstGroup = context.pageLiveData.find(data => data?.name === 'SubWebPeople').data?.length < 1
  const isFirstGroupTitleEmpty = !isNewItem
    ? (
      context.pageLiveData.find(data => data?.name === 'SubWebPeople').data[0]?.name === ''
      || context.pageLiveData.find(data => data?.name === 'SubWebPeople').data[0]?.name === undefined
    ) : !!isFirstGroup

  return isFirstGroup || isFirstGroupTitleEmpty ? Yup.object().shape({
    title: Yup.string(),
    list: Yup.array().min(1, 'Deve adicionar pelo menos uma pessoa').required('Campo obrigatório'),
  }) : Yup.object().shape({
    title: Yup.string().required('Campo obrigatório'),
    list: Yup.array().min(1, 'Deve adicionar pelo menos uma pessoa').required('Campo obrigatório'),
  })
}

export const getDefault = ({ lang }) => {
  const data = {
    name: 'SubWebPeople',
    isLoading: false,
    isTabsLoading: false,
    hasError: false,
    title: lang === 'pt' ? 'Pessoas' : 'People',
    structure: false,
    data: [],
    tabs: [],
    activeColor: '#0EB4BD',
  }
  return data
}

